import { Navigate, Outlet } from 'react-router-dom';
import { Authorities } from 'src/models/authorizations.model';
import { useAppSelector } from 'src/reducers';
import { SYSTEM_ROLE } from '../../../config/constants';

type PrivateRouteProps = {
  capabilities?: Authorities[];
};

export const PrivateRoute = (props: PrivateRouteProps) => {
  const { capabilities } = props;
  const { user, isAuthenticated, initializing } = useAppSelector(state => state.authentication);

  const isAuthorized = user?.authority?.name === SYSTEM_ROLE || user?.capabilities?.some(auth => capabilities?.includes(auth));

  if (initializing) {
    return <></>;
  }

  if (isAuthenticated) {
    if (isAuthorized) {
      return <Outlet />;
    } else {
      return <div className="m-1 h-100">Non sei autorizzato a visualizzare questa pagina </div>;
    }
  } else {
    return <Navigate to={{ pathname: '/' }} />;
  }
};
